module.exports = __webpack_public_path__ + "img/drawing.0841f3bd.jpg";